module.exports = __webpack_public_path__ + "img/left_right_layout_5.631d8bd7.svg";